export default __webpack_public_path__ + "static/assets/0011b33b66457f864a30734dacb731b7.gif";